export const languages = [
    {
        "name": "english",
        "code": "en-GB",
        "native": true,
        "enabled": true,
    },
    {
        "name": "french",
        "code": "fr-FR",
        "native": true,
        "enabled": true,
    },
    {
        "name": "spanish",
        "code": "es-ES",
        "native": true,
        "enabled": true,
    },
    {
        "name": "german",
        "code": "de-DE",
        "native": true,
        "enabled": true,
    }
]